import { render, staticRenderFns } from "./BetaWelcome.vue?vue&type=template&id=d4ecfc64&scoped=true&"
import script from "./BetaWelcome.vue?vue&type=script&lang=js&"
export * from "./BetaWelcome.vue?vue&type=script&lang=js&"
import style0 from "./BetaWelcome.vue?vue&type=style&index=0&id=d4ecfc64&scoped=true&lang=scss&"
import style1 from "./BetaWelcome.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ecfc64",
  null
  
)

export default component.exports